import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Adminportal } from "../models/adminportal";
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { UserType } from "../models/adduser";
@Injectable({
  providedIn: 'root'
})
export class AdminportalService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'authenticate/ret/hCw230b862-99250-4f71-a1271-f8bqxvvbner121967d35d/candidate/AOaemvOPybXzswaLnMtcT3gMn3sp3/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

//   getAllEntities(filter: string, pagesize: number, pagenumber: number): Observable<Array<Entity>> { 
//     return this.httpService.get(this.apiEndpoint + 'getAllEntities?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {      
//       if (result.Success) {
//         return result.Data;
//       } else {
//         return [];
//       }
//     }));
//   }
//   getAllEmployees(filter: string, pagesize: number, pagenumber: number): Observable<Array<Employees>> {
//     return this.httpService.get(this.apiEndpoint + 'getAllEmployees?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {      
//       if (result.Success) {
//         return result.Data;
//       } else {
//         return [];
//       }
//     }));
//   }
//   getAllVendors(filter: string, pagesize: number, pagenumber: number): Observable<Array<Vendor>> { 
//     return this.httpService.get(this.apiEndpoint + 'getAllVendors?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {           
//       if (result.Success) {
//         return result.Data;
//       } else {
//         return [];
//       }
//     }));
//   }
  getGeneralpreferencesByName(Generalpreference_Name?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'getGeneralpreferencesByName?GeneralpreferenceName='+ (Generalpreference_Name ? Generalpreference_Name : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }      
    }));
  } 
  getAllAdmin(filter: string, pagesize: number, pagenumber: number,filterType:number): Observable<Array<Adminportal>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllAddUser?filter=' + (filter ? filter : '') + '&pagesize=' + (pagesize ? pagesize : 0) + '&pagenumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)).pipe(map((result: any) => {      
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewAdmin(UserName?: string): Observable<Array<Adminportal>> {
    return this.httpService.get(this.apiEndpoint + 'viewUser/' + (UserName ? UserName : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveAdmin(entities: Adminportal): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'register/', entities).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteAdmin(AddUserID?: number): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteUser/' + (AddUserID ? AddUserID : ''), AddUserID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(UserName?: string,UserId?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?AddUserName=' + (UserName ? UserName : '')+ '&AddUserid=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
        return result; 
    }));
  }
  checkEmail(Email?: string, UserId?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Email=' + (Email ? Email : '')+ '&UserId=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
      return result;
    })); 
  }

getusertype(): Observable<Array<UserType>> { 
  return this.httpService.get(this.apiEndpoint + 'getusertype').pipe(map((result: any) => {      
    if (result.Success) {
      return result.Data;
    } else {
      return [];
    }
  }));
}
// getEmpdetails(EmpRefId?: number): Observable<Array<EmployeeAdditionalDetails>> {
//   return this.httpService.get(this.apiEndpoint + 'getEmpdetails/'+ (EmpRefId ? EmpRefId : 0)).pipe(map((result: any) => {
//     if (result.Success) {
//       return result.Data;
//     } else {
//       return [];
//     }
//   }));
// }

}